var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.50008C5.5 1.03984 5.1269 0.666748 4.66667 0.666748C4.20643 0.666748 3.83333 1.03984 3.83333 1.50008H3C1.61929 1.50008 0.5 2.61937 0.5 4.00008V14.8334C0.5 16.2141 1.61929 17.3334 3 17.3334H13C14.3807 17.3334 15.5 16.2141 15.5 14.8334V4.00008C15.5 2.61937 14.3807 1.50008 13 1.50008H12.1667C12.1667 1.03984 11.7936 0.666748 11.3333 0.666748C10.8731 0.666748 10.5 1.03984 10.5 1.50008H5.5ZM13.8333 4.83342V4.00008C13.8333 3.53984 13.4602 3.16675 13 3.16675H12.1667C12.1667 3.62699 11.7936 4.00008 11.3333 4.00008C10.8731 4.00008 10.5 3.62699 10.5 3.16675H5.5C5.5 3.62699 5.1269 4.00008 4.66667 4.00008C4.20643 4.00008 3.83333 3.62699 3.83333 3.16675H3C2.53976 3.16675 2.16667 3.53984 2.16667 4.00008V4.83342H13.8333ZM2.16667 6.50008V14.8334C2.16667 15.2937 2.53976 15.6667 3 15.6667H13C13.4602 15.6667 13.8333 15.2937 13.8333 14.8334V6.50008H2.16667Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.8157492f24ce1ff8036451f6fcf84872.svg";
export { ForwardRef as ReactComponent };